import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import * as S from './EndConversationPopup.styles.js';

export const EndConversationPopup = ({ isOpen, onClose, onSave, isSaving = false }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  // const [emailReport, setEmailReport] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
      // Prevent body scroll when popup is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
      // Reset form when closed
      setUserEmail('');
      // setEmailReport(false);
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match animation duration
  };

  const handleBackdropClick = () => {
    handleClose();
  };

  const handleSave = async () => {
    if (!userEmail.trim()) {
      alert('Please enter your email address');
      return;
    }

    await onSave(userEmail);
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      <S.Backdrop $isClosing={isClosing} onClick={handleBackdropClick} />
      <S.PopupOverlay $isClosing={isClosing}>
        <S.PopupContainer>
          <S.PopupHeader>
            <S.HeaderContent>
              <S.Title>Share Conversation</S.Title>
              <S.Subtitle>
                Please enter your email address to receive the conversation report.
              </S.Subtitle>
            </S.HeaderContent>
            <S.CloseButton onClick={handleClose} aria-label="Close end conversation">
              <X />
            </S.CloseButton>
          </S.PopupHeader>

          <S.FormContent>
            <S.EmailInput
              type="email"
              placeholder="Enter your email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              disabled={isSaving}
            />

            {/* <S.CheckboxContainer>
              <S.Checkbox
                type="checkbox"
                id="emailReportCheck"
                checked={emailReport}
                onChange={(e) => setEmailReport(e.target.checked)}
                disabled={isSaving}
              />
              <S.CheckboxLabel htmlFor="emailReportCheck">
                <Mail size={16} style={{ display: 'inline', marginRight: '4px' }} />
                Email me the conversation report
              </S.CheckboxLabel>
            </S.CheckboxContainer> */}

            <S.ButtonGroup>
              <S.PrimaryButton onClick={handleSave} disabled={isSaving}>
                {isSaving ? 'sharing...' : 'Share & End'}
              </S.PrimaryButton>
              <S.SecondaryButton onClick={handleClose} disabled={isSaving}>
                Cancel
              </S.SecondaryButton>
            </S.ButtonGroup>
          </S.FormContent>
        </S.PopupContainer>
      </S.PopupOverlay>
    </>
  );
};
